module.exports = __webpack_public_path__ + "static/media/Questions-11-18.46ca6d42.png";